import { Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

import { BaseInputComponent } from '../base-input.component';
import { TypedFormGroup } from '@feature/forms/form-model';

@UntilDestroy()
@Component({
    selector: 'wai-form-input-yes-no',
    templateUrl: './form-input-yes-no.component.html',
    styleUrls: ['./form-input-yes-no.component.scss'],
    standalone: false
})
export class FormInputYesNoComponent extends BaseInputComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @Input() public label: string;
  @Input() public caption: string;
  @Input() public icon: string;
}
